var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c(
        "el-aside",
        { class: [_vm.isCollapse ? "menu-collapsed" : "menu-expanded"] },
        [
          _c(
            "div",
            { staticClass: "hover-image", on: { click: _vm.backToHome } },
            [
              _vm.isCollapse
                ? _c("img", {
                    staticClass: "image",
                    attrs: {
                      src: require("../../../content/images/vnta 1.png"),
                    },
                  })
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-menu",
            {
              staticClass: "el-menu-vertical",
              attrs: {
                "menu-trigger": "click",
                router: true,
                "default-active": _vm.count,
                collapse: _vm.isCollapse,
                "collapse-transition": true,
              },
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn_toggle",
                  attrs: { index: "1000", plain: "" },
                  on: { click: _vm.handleOpen },
                },
                [
                  _c("img", {
                    attrs: { src: require("../../../content/icon/toggle.svg") },
                  }),
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.rolesAccount, function (item, index) {
                return [
                  !item.childrens.length
                    ? _c(
                        "el-menu-item",
                        {
                          key: index,
                          class:
                            item.icon == "trangchu.svg"
                              ? "item-actived custom_home"
                              : "item-actived custom_menu",
                          attrs: {
                            index: (index + 1).toString(),
                            route: item.path,
                          },
                          on: {
                            click: function ($event) {
                              _vm.handleClosePopup((index + 1).toString())
                            },
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: "../../../content/icon/" + item.icon,
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "name_menu_tooltip",
                              attrs: { slot: "title" },
                              slot: "title",
                            },
                            [_vm._v(" " + _vm._s(item.name))]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.childrens.length
                    ? _c(
                        "el-submenu",
                        {
                          key: index,
                          attrs: { index: (index + 1).toString() },
                          nativeOn: {
                            mouseover: function ($event) {
                              return _vm.mouseover($event)
                            },
                          },
                        },
                        [
                          _c("template", { slot: "title" }, [
                            _c("img", {
                              attrs: {
                                src: "../../../content/icon/" + item.icon,
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { attrs: { slot: "title" }, slot: "title" },
                              [_vm._v(_vm._s(item.check))]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(item.childrens, function (subcat, inx) {
                            return _c(
                              "el-menu-item",
                              {
                                key: inx,
                                staticClass: "item-active-tow",
                                attrs: {
                                  disabled: inx == 0,
                                  route: subcat.path,
                                  index:
                                    inx == 0
                                      ? ""
                                      : (index + 1).toString() +
                                        "-" +
                                        (inx + 1).toString(),
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.handleClosePopup(
                                      inx == 0
                                        ? ""
                                        : (index + 1).toString() +
                                            "-" +
                                            (inx + 1).toString(),
                                      subcat
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    style: inx == 0 ? "font-weight: bold;" : "",
                                  },
                                  [_vm._v(_vm._s(subcat.name))]
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "I am the title",
            visible: _vm.drawer,
            direction: "ltr",
            size: "260px",
            "with-header": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c("div", { staticStyle: { width: "100%" } }, [
            _c(
              "div",
              { staticClass: "menu_headrt" },
              [
                _c(
                  "div",
                  { staticStyle: { display: "flex", padding: "10px 0" } },
                  [
                    _c("img", {
                      staticClass: "image",
                      staticStyle: { margin: "0 auto" },
                      attrs: {
                        src: require("../../../content/images/vnta 1.png"),
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticStyle: {
                      border: "none",
                      "font-size": "23px",
                      color: "#378ede",
                      position: "absolute",
                      top: "12px",
                      right: "0",
                    },
                    attrs: { plain: "" },
                    on: {
                      click: function ($event) {
                        _vm.drawer = false
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "el-icon-s-fold",
                      staticStyle: { "font-size": "23px" },
                    }),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-menu",
            {
              staticClass: "el-menu-vertical",
              attrs: {
                router: true,
                "default-active": _vm.count,
                collapse: false,
                "collapse-transition": true,
              },
            },
            [
              _vm._l(_vm.rolesAccount, function (item, index) {
                return [
                  !item.childrens.length
                    ? _c(
                        "el-menu-item",
                        {
                          key: index,
                          staticClass: "item-actived",
                          attrs: {
                            index: (index + 1).toString(),
                            route: item.path,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleClick(index)
                            },
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: "../../../content/icon/" + item.icon,
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "name_menu",
                              attrs: { slot: "title" },
                              slot: "title",
                            },
                            [_vm._v(" " + _vm._s(item.name))]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.childrens.length
                    ? _c(
                        "el-submenu",
                        {
                          key: index,
                          attrs: { index: (index + 1).toString() },
                        },
                        [
                          _c("template", { slot: "title" }, [
                            _c("img", {
                              attrs: {
                                src: "../../../content/icon/" + item.icon,
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "name_menu",
                                attrs: { slot: "title" },
                                slot: "title",
                              },
                              [_vm._v(_vm._s(item.name))]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(item.childrens, function (subcat, inx) {
                            return _c(
                              "el-menu-item",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: inx != 0,
                                    expression: "inx != 0",
                                  },
                                ],
                                key: inx,
                                staticClass: "item-active-tow",
                                attrs: {
                                  index:
                                    (index + 1).toString() +
                                    "-" +
                                    (inx + 1).toString(),
                                  route: subcat.path,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleClickv2(index, inx, subcat)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(subcat.name) +
                                    "\n          "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }